import {type ParserT, Parser, string} from '@freckle/parser'

export type RlDomainIdT = string

export const parse: ParserT<RlDomainIdT> = Parser.map(
  string(),
  'RlDomainIdT.fromString',
  fromString
)

/** @internal */
export function fromString(rlDomainId: string): RlDomainIdT {
  return rlDomainId
}
